import { createSlice } from '@reduxjs/toolkit';
import { BookingAvailabilityHoursObject, BookingDetailObject, BookingState } from '../../params/redux/booking';
import { createBookingThunk, fetchBookingDetailThunk, fetchBookingSlotsDetailThunk } from '../../redux/thunks/booking';

// Initial state with default values for authentication and user info
const initialState: BookingState = {
    bookingDetails: null,
    availabilityHours: [],
    formDetails: '',
    selectedDate: '',
    selectedTimezone: '',
    loaders: {
        isLoading: false,
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const bookingSlice = createSlice({
    // Slice name
    name: 'booking',
    // inital state for the slice
    initialState,
    reducers: {
        // Resets loading states related to app actions
        resettingBookingLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingBookingData: () => initialState
    },
    extraReducers: (builder) => {
        // Handle async actions for login
        builder
            .addCase(fetchBookingDetailThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(fetchBookingDetailThunk.fulfilled, (state, action) => {
                const data = action.payload as BookingDetailObject;
                const formFields = JSON.parse(data.calendar_booking.form_json).fields;
                data.calendar_booking.form_fields = formFields;
                state.bookingDetails = data;
            })
            .addCase(fetchBookingDetailThunk.rejected, () => {
                //
            });
        builder
            .addCase(fetchBookingSlotsDetailThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isLoading = true;
            })
            .addCase(fetchBookingSlotsDetailThunk.fulfilled, (state, action) => {
                state.availabilityHours = action.payload as BookingAvailabilityHoursObject[];
            })
            .addCase(fetchBookingSlotsDetailThunk.rejected, () => {
                //
            });
        builder
            .addCase(createBookingThunk.pending, (state) => {
                // Set loading flag during login request
                state.loaders.isCreating = true;
            })
            .addCase(createBookingThunk.fulfilled, () => {
                //
            })
            .addCase(createBookingThunk.rejected, () => {
                //
            });
    }
});

// Exporting actions for updating app state
export const {
    resettingBookingData,
    resettingBookingLoader
} = bookingSlice.actions;

// Exporting the reducer to be used in the store
export default bookingSlice.reducer;
